<mat-card class="cardWithShadow">
  <mat-card-content style="padding: 36px 36px 0px 36px">
    <mat-card-title>
      <h2>
        {{
          isEditMode ? "Editar Ingreso" : "Nuevo Ingreso a Almacén de Insumos"
        }}
      </h2>
    </mat-card-title>

    <div
      *ngIf="isLoading"
      class="d-flex flex-col flex-wrap align-items-center justify-content-center"
      style="padding-bottom: 36px"
    >
      <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
      <p>
        {{
          isEditMode ? "Cargando Ingreso para Edición...." : "Nuevo Ingreso...."
        }}
      </p>
    </div>

    <ng-container *ngIf="!isLoading">
      <div>
        <mat-radio-group [(ngModel)]="selectedFoodInflowType" class="row">
          <ng-container *ngIf="!isEditMode">
            <mat-radio-button
              color="primary"
              *ngFor="let FOOD_INFLOW_CATEGORY of FOOD_INFLOW_CATEGORIES"
              [value]="FOOD_INFLOW_CATEGORY"
            >
              {{ FOOD_INFLOW_CATEGORY }}
            </mat-radio-button>
          </ng-container>
          <ng-container *ngIf="isEditMode">
            <mat-radio-button
              color="primary"
              [value]="selectedFoodInflowType"
              [checked]="true"
              [disabled]="true"
            >
              {{ selectedFoodInflowType }}
            </mat-radio-button>
          </ng-container>
        </mat-radio-group>
      </div>

      <div *ngIf="selectedFoodInflowType === 'Con documentos contables'">
        <h3>Datos de la factura</h3>

        <form [formGroup]="ingresoForm" class="row justify-content-between">
          <div class="col-sm-4 w-100">
            <mat-label class="mat-subtitle-2 f-w-600 d-block m-b-24"
              >Razón Social</mat-label
            >
            <mat-form-field appearance="outline" class="w-100 hide-hint">
              <input
                type="text"
                placeholder="Razón Social"
                matInput
                required
                [formControl]="providerControl"
                [matAutocomplete]="autocompleteSupplier"
              />
              <mat-autocomplete
                #autocompleteSupplier="matAutocomplete"
                [displayWith]="getOptionTextProveedor"
                (optionSelected)="onSelectionProviderChanged($event)"
              >
                <mat-option
                  *ngFor="let provider of autocompleteProviders$ | async"
                  [value]="provider"
                >
                  {{ provider.razonSocial }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <div class="col-sm-4 w-100">
            <mat-label class="mat-subtitle-2 f-w-600 d-block m-b-24"
              >RUC</mat-label
            >
            <mat-form-field appearance="outline" class="w-100 hide-hint">
              <input
                readonly
                matInput
                placeholder="RUC"
                formControlName="ruc"
                name="ruc"
                required
              />
            </mat-form-field>
          </div>
          <div class="col-sm-4 w-100">
            <mat-label class="mat-subtitle-2 f-w-600 d-block m-b-24"
              >Número de Factura</mat-label
            >
            <mat-form-field appearance="outline" class="w-100 hide-hint">
              <input
                matInput
                placeholder="Número de Factura"
                formControlName="numFactura"
                name="numFactura"
                required
              />
            </mat-form-field>
          </div>
          <div class="col-sm-4 w-100">
            <mat-label class="mat-subtitle-2 f-w-600 d-block m-b-24"
              >Ubicación</mat-label
            >
            <mat-form-field appearance="outline" class="w-100 hide-hint">
              <input
                type="text"
                placeholder="Ubicación"
                matInput
                required
                [formControl]="ubicacionControl"
                [matAutocomplete]="autoUbicacion"
              />
              <mat-autocomplete #autoUbicacion="matAutocomplete">
                <mat-option
                  *ngFor="let ubicacion of ubicaciones"
                  [value]="ubicacion"
                >
                  {{ ubicacion }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <div class="col-sm-4 w-100">
            <mat-label class="mat-subtitle-2 f-w-600 d-block m-b-24"
              >Fecha de Factura</mat-label
            >
            <mat-form-field appearance="outline" class="w-100 hide-hint">
              <input
                matInput
                [matDatepicker]="picker"
                formControlName="fechaFactura"
                placeholder="Día/Mes/Año"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="picker"
              ></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-sm-4 w-100">
            <mat-label class="mat-subtitle-2 f-w-600 d-block m-b-24"
              >Observación (opcional)</mat-label
            >
            <mat-form-field appearance="outline" class="w-100 hide-hint">
              <textarea
                matInput
                cdkTextareaAutosize
                formControlName="observation"
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="5"
                placeholder="Observación..."
              ></textarea>
            </mat-form-field>
          </div>
        </form>
      </div>

      <div *ngIf="selectedFoodInflowType === 'Sin Factura'">
        <h3>Datos del File</h3>
        <form [formGroup]="ingresoForm" class="row justify-content-between">
          <div class="col-sm-4 w-100">
            <mat-label class="mat-subtitle-2 f-w-600 d-block m-b-24"
              >Proveedor</mat-label
            >
            <mat-form-field appearance="outline" class="w-100 hide-hint">
              <input
                matInput
                type="text"
                placeholder="Proveedor"
                required
                [formControl]="providerControl"
                [matAutocomplete]="autoProveedor"
                (input)="onProveedorTyped($event)"
              />
              <mat-autocomplete
                #autoProveedor="matAutocomplete"
                [displayWith]="getOptionTextProveedor"
                (optionSelected)="onSelectionProviderChanged($event)"
              >
                <mat-option
                  *ngFor="let provider of autocompleteProviders$ | async"
                  [value]="provider"
                >
                  {{ provider.razonSocial }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <div class="col-sm-4 w-100">
            <mat-label class="mat-subtitle-2 f-w-600 d-block m-b-24"
              >Nro File</mat-label
            >
            <mat-form-field appearance="outline" class="w-100 hide-hint">
              <input
                type="text"
                placeholder="Nro File"
                matInput
                required
                [formControl]="fileControl"
                [matAutocomplete]="fileNumberAutocomplete"
              />
              <mat-autocomplete
                #fileNumberAutocomplete="matAutocomplete"
                [displayWith]="getFileNumberText"
                (optionSelected)="onFileNumberSelected($event)"
              >
                <mat-option
                  *ngFor="let file of autocompleteFiles$ | async"
                  [value]="file"
                >
                  <span>{{ file.fileNumber }}</span>
                  <span *ngIf="file.fileExtend">-{{ file.fileExtend }}</span>
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <div class="col-sm-4 w-100">
            <mat-label class="mat-subtitle-2 f-w-600 d-block m-b-24"
              >Número de Recibo</mat-label
            >
            <mat-form-field appearance="outline" class="w-100 hide-hint">
              <input
                matInput
                placeholder="Número de Recibo"
                formControlName="numRecibo"
                name="numRecibo"
                required
              />
            </mat-form-field>
          </div>
          <div class="col-sm-4 w-100">
            <mat-label class="mat-subtitle-2 f-w-600 d-block m-b-24"
              >Ubicación</mat-label
            >
            <mat-form-field appearance="outline" class="w-100 hide-hint">
              <input
                type="text"
                placeholder="Ubicación"
                matInput
                required
                [formControl]="ubicacionControl"
                [matAutocomplete]="autoUbicacion"
              />
              <mat-autocomplete #autoUbicacion="matAutocomplete">
                <mat-option
                  *ngFor="let ubicacion of ubicaciones"
                  [value]="ubicacion"
                >
                  {{ ubicacion }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <div class="col-sm-4 w-100">
            <mat-label class="mat-subtitle-2 f-w-600 d-block m-b-24"
              >Fecha de Recibo</mat-label
            >
            <mat-form-field appearance="outline" class="w-100 hide-hint">
              <input
                matInput
                [matDatepicker]="pickerRecibo"
                formControlName="fechaRecibo"
                placeholder="Día/Mes/Año"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="pickerRecibo"
              ></mat-datepicker-toggle>
              <mat-datepicker #pickerRecibo></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-sm-4 w-100">
            <mat-label class="mat-subtitle-2 f-w-600 d-block m-b-24"
              >Observación (opcional)</mat-label
            >
            <mat-form-field appearance="outline" class="w-100 hide-hint">
              <textarea
                matInput
                cdkTextareaAutosize
                formControlName="observation"
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="5"
                placeholder="Observación..."
              ></textarea>
            </mat-form-field>
          </div>
        </form>
      </div>
      <div *ngIf="selectedFoodInflowType === 'Sin File'" class="divInformation">
        <h3>Datos del Ingreso Sin File</h3>

        <form [formGroup]="ingresoForm" class="row justify-content-between">
          <div class="col-sm-4 w-100">
            <mat-label class="mat-subtitle-2 f-w-600 d-block m-b-24"
              >Fecha de Adquisición</mat-label
            >
            <mat-form-field appearance="outline" class="w-100 hide-hint">
              <input
                matInput
                [matDatepicker]="fechaReciboPicker"
                formControlName="fechaRecibo"
                placeholder="Día/Mes/Año"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="fechaReciboPicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #fechaReciboPicker></mat-datepicker>
            </mat-form-field>
          </div>

          <div class="col-sm-4 w-100">
            <mat-label class="mat-subtitle-2 f-w-600 d-block m-b-24"
              >Ubicación</mat-label
            >
            <mat-form-field appearance="outline" class="w-100 hide-hint">
              <input
                type="text"
                placeholder="Ubicación"
                matInput
                required
                [formControl]="ubicacionControl"
                [matAutocomplete]="autoUbicacion"
              />
              <mat-autocomplete #autoUbicacion="matAutocomplete">
                <mat-option
                  *ngFor="let ubicacion of ubicaciones"
                  [value]="ubicacion"
                >
                  {{ ubicacion }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <div class="col-sm-4 w-100">
            <mat-label class="mat-subtitle-2 f-w-600 d-block m-b-24"
              >Observación</mat-label
            >
            <mat-form-field appearance="outline" class="w-100 hide-hint">
              <textarea
                matInput
                cdkTextareaAutosize
                formControlName="observation"
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="5"
                placeholder="Observación..."
              ></textarea>
            </mat-form-field>
          </div>
        </form>
      </div>

      <div>
        <h3>SKUs del ingreso</h3>

        <form [formGroup]="ingresoForm">
          <div
            formGroupName="insumoAlmacen"
            class="row justify-content-between"
          >
            <div class="col-sm-4 w-100">
              <mat-label class="mat-subtitle-2 f-w-600 d-block m-b-24"
                >SKU</mat-label
              >
              <mat-form-field appearance="outline" class="w-100 hide-hint">
                <input
                  matInput
                  type="text"
                  placeholder="Elige un insumo"
                  [formControl]="foodItemControl"
                  [matAutocomplete]="autoInsumo"
                />
                <mat-autocomplete
                  #autoInsumo="matAutocomplete"
                  [displayWith]="getOptionText"
                  (optionSelected)="onSelectionChanged($event)"
                >
                  <mat-option
                    *ngFor="let foodItem of autocompleteFoodItem$ | async"
                    [value]="foodItem"
                  >
                    {{ foodItem.nombreInsumo }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </div>
            <div class="col-sm-4 w-100">
              <mat-label class="mat-subtitle-2 f-w-600 d-block m-b-24"
                >Unidad de Medida</mat-label
              >
              <mat-form-field appearance="outline" class="w-100 hide-hint">
                <input
                  matInput
                  placeholder="Unidad de Medida"
                  formControlName="unidadMedida"
                  name="unidad de medida"
                  readonly
                />
              </mat-form-field>
            </div>
            <div class="col-sm-4 w-100">
              <mat-label class="mat-subtitle-2 f-w-600 d-block m-b-24"
                >Cantidad</mat-label
              >
              <mat-form-field appearance="outline" class="w-100 hide-hint">
                <input
                  matInput
                  placeholder="Cantidad"
                  formControlName="cantidad"
                  name="cantidad"
                  type="number"
                />
              </mat-form-field>
            </div>
            <div class="col-sm-4 w-100">
              <mat-label class="mat-subtitle-2 f-w-600 d-block m-b-24"
                >Precio Total</mat-label
              >
              <mat-form-field
                appearance="outline"
                class="w-100 hide-hint"
                [ngClass]="{ warning: isWarning }"
              >
                <input
                  matInput
                  placeholder="Costo Total"
                  formControlName="costo"
                  name="costo"
                  type="number"
                />
                <mat-error
                  *ngIf="
                    ingresoForm.get('insumoAlmacen.costo')?.errors?.[
                      'fueraDeRango'
                    ]
                  "
                >
                  El precio no está dentro del *precio referencial.
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="col-sm-4 w-100">
            <button mat-mini-fab color="primary" (click)="addFoodItemSku()">
              <mat-icon>add</mat-icon>
            </button>
          </div>
        </form>

        <div *ngIf="isWarning">
          <p class="text-underline">
            *Precio referencial:
            {{
              (
                this.foodItemControl.value.precioReferencial *
                0.9 *
                this.ingresoForm.value.insumoAlmacen.cantidad
              ).toFixed(2) +
                " - " +
                (
                  this.foodItemControl.value.precioReferencial *
                  1.1 *
                  this.ingresoForm.value.insumoAlmacen.cantidad
                ).toFixed(2)
            }}
          </p>
        </div>

        <mat-card-content
          [style.display]="
            !isLoading && dataSource.filteredData.length !== 0
              ? 'block'
              : 'none'
          "
          style="padding: 36px"
        >
          <div class="table-responsive">
            <table
              mat-table
              [dataSource]="dataSource"
              matSort
              class="no-wrap m-t-0 v-middle w-100"
            >
              <ng-container matColumnDef="nombre">
                <th
                  class="f-w-600 f-s-15 custom-column"
                  mat-header-cell
                  *matHeaderCellDef
                >
                  Nombre
                </th>
                <td
                  class="f-w-600 f-s-15 custom-column"
                  mat-cell
                  *matCellDef="let element"
                >
                  {{ element.nombreInsumo }}
                </td>
              </ng-container>

              <ng-container matColumnDef="UM">
                <th
                  class="f-w-600 f-s-15 custom-column"
                  mat-header-cell
                  *matHeaderCellDef
                >
                  Unidad de Medida
                </th>
                <td
                  class="f-w-600 f-s-15 custom-column"
                  mat-cell
                  *matCellDef="let element"
                >
                  {{ element.unidadMedida }}
                </td>
              </ng-container>

              <ng-container matColumnDef="cantidad">
                <th
                  class="f-w-600 f-s-15 custom-column"
                  mat-header-cell
                  *matHeaderCellDef
                >
                  Cantidad
                </th>
                <td
                  class="f-w-600 f-s-15 custom-column"
                  mat-cell
                  *matCellDef="let element"
                >
                  {{ element.cantidad }}
                </td>
              </ng-container>

              <ng-container matColumnDef="costoTotal">
                <th
                  class="f-w-600 f-s-15 custom-column"
                  mat-header-cell
                  *matHeaderCellDef
                >
                  Precio Total
                </th>
                <td
                  class="f-w-600 f-s-15 custom-column"
                  mat-cell
                  *matCellDef="let element"
                >
                  {{ element.costo }}
                </td>
              </ng-container>

              <ng-container matColumnDef="costoUnitario">
                <th
                  class="f-w-600 f-s-15 custom-column"
                  mat-header-cell
                  *matHeaderCellDef
                >
                  Precio Unitario
                </th>
                <td
                  class="f-w-600 f-s-15 custom-column"
                  mat-cell
                  *matCellDef="let element"
                >
                  {{ (element.costo / element.cantidad).toFixed(2) }}
                </td>
              </ng-container>

              <ng-container matColumnDef="modificar">
                <th
                  class="f-w-600 f-s-15 custom-column"
                  mat-header-cell
                  *matHeaderCellDef
                >
                  Editar
                </th>
                <td
                  class="f-w-600 f-s-15 custom-column"
                  mat-cell
                  *matCellDef="let _; let foodItemIndex = index"
                >
                  <button
                    mat-icon-button
                    (click)="openDialogModify(foodItemIndex)"
                  >
                    <mat-icon class="icon-color">edit</mat-icon>
                  </button>
                </td>
              </ng-container>

              <ng-container matColumnDef="eliminar">
                <th
                  class="f-w-600 f-s-15 custom-column"
                  mat-header-cell
                  *matHeaderCellDef
                >
                  Eliminar
                </th>
                <td
                  class="f-w-600 f-s-15 custom-column"
                  mat-cell
                  *matCellDef="let inflow; let i = index"
                >
                  <button
                    mat-icon-button
                    (click)="removeFoodItemFromInflow(inflow, i)"
                  >
                    <mat-icon class="icon-color">delete</mat-icon>
                  </button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
          </div>
          <div *ngIf="addedIngreso.length > 0">
            <button
              *ngIf="ingresoId == null"
              mat-raised-button
              color="primary"
              (click)="addIngreso()"
            >
              Confirmar Nuevo Ingreso
            </button>
            <button
              *ngIf="ingresoId"
              mat-raised-button
              color="primary"
              (click)="updateIngreso()"
              [disabled]="!hasIngresoBeenEdited()"
            >
              Actualizar Ingreso
            </button>
          </div>
        </mat-card-content>
      </div>
    </ng-container>
  </mat-card-content>
</mat-card>
